import classNames from 'classnames';
import { CelectButton, CelectButtonProps } from '~/components/Form/Celect/Button/CelectButton';
import { CelectModal } from '~/components/Form/Celect/Modal';
import { CelectOption } from '~/components/Form/Celect/Option';
import { CelectRoot, CelectRootProps } from '~/components/Form/Celect/Root/CelectRoot';
import styles from './Celect.module.scss';

export type CelectProps = CelectRootProps & {
  label?: CelectButtonProps['children'];
};
export const Celect = ({ className, label, children, ...props }: CelectProps) => (
  <CelectRoot className={classNames(styles.root, className)} {...props}>
    <CelectButton>{label}</CelectButton>
    <CelectModal className={styles.modal}>{children}</CelectModal>
  </CelectRoot>
);

Celect.Root = CelectRoot;
Celect.Button = CelectButton;
Celect.Option = CelectOption;
Celect.Modal = CelectModal;
